import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';

import { IInput } from './input.interface';
import { IErrors } from './errors.interface';

import { ControlValueAccessor } from './../../../shared/interfaces/forms.setup';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => InputSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})

export class InputSharedComponent implements ControlValueAccessor {
    @Input() input: IInput;
    @Input() errors: Array<IErrors> = [];
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';

    onChange: any = () => {};
    onTouched: any = () => {};

    get type(): string { return (this.input.type) ? this.input.type : 'text'; }
    get id(): string { return (this.input.id) ? this.input.id : ''; }
    get placeholder(): string { return (this.input.placeholder) ? this.input.placeholder : 'Start Typing'; }

    get value(): any { return this._value; }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    updateValue(event: KeyboardEvent): void {
        this.value = (event.target as HTMLInputElement).value;
    }
}
